import React from 'react';
import { useAuth } from '../../context/AuthContext';
import SupplierDashboard from './SupplierDashboard';
import CustomerDashboard from './CustomerDashboard';
import AdminDashboard    from './AdminDashboard';

// Routes to the correct dashboard based on user role
export default function DashboardPage() {
  const { user } = useAuth();

  if (user?.role === 'admin')    return <AdminDashboard />;
  if (user?.role === 'supplier') return <SupplierDashboard />;
  return <CustomerDashboard />;
}